import { csv } from "d3-fetch";

// __ASSET_BASE__ is substituted at build time (see rollup.config.js). It is an
// absolute origin in production — the bundle runs on equable.org, so a
// root-relative path would look for the CSVs there — and an empty string
// locally, where public/data is served by the dev server.
const BASE = __ASSET_BASE__;

export default function getData(status, asset) {
  return csv(`${BASE}/data/${status}/${asset}.csv`);
}
